import { gql } from "@apollo/client";
import { PageDataFragment } from "@/fragments/PageData";

const CoverStoryLandingQuery = gql`
  ${PageDataFragment}
  query GetCoverStoryPageData($databaseId: ID!, $asPreview: Boolean = false, $language: String = "en") {
    rhPage(id: $databaseId, asPreview: $asPreview, language: $language) {
      title
      uri
      ...PageData
      featuredCoverStory {
        databaseId
        title
        uri
        gameData {
          gameNumber
          coverStoryDate
        }
      }
      coverStoryLanding {
        coverStoryHero {
          headline
          subhead
          ctaLabel
          resumeCtaLabel
          solvedCtaLabel
          lostCtaLabel
          image {
            ...ACFMedia
          }
        }
      }
    }
    coverStories(where: { language: $language, filterCoverStoryByDate: true, offsetPagination: { size: 15, offset: 1 }}) {
      pageInfo {
        offsetPagination {
          hasMore
          total
        }
      }
      nodes {
        databaseId
        title
        uri
        gameData {
          gameNumber
          coverStoryDate
        }
      }
    }
  }
`;

export default CoverStoryLandingQuery;